import { render, staticRenderFns } from "./followGoods_view.vue?vue&type=template&id=740b6d1c&scoped=true&"
import script from "./followGoods_view.vue?vue&type=script&lang=js&"
export * from "./followGoods_view.vue?vue&type=script&lang=js&"
import style0 from "./followGoods_view.vue?vue&type=style&index=0&id=740b6d1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b6d1c",
  null
  
)

export default component.exports